<script>
    import playButton from "@songfinch/customer/assets/images/play_video.png";
    import "@songfinch/customer/stylesheets/includes/helpers/video-link.pcss";
    import fancyboxDirective from "@songfinch/customer/directives/fancybox/fancybox_directive.js";

    export default {
        name: "ImageWithSliderOnRight",
        directives: {fancyboxDirective},
        props: {
            data: {
                type: Object,
                required: true
            },
            withoutNum: Boolean
        },
        data() {
            return {
                playButton,
                imageFormat: {
                    transformation: [{width: 1200, crop: "limit"}]
                },
                sliderOptions: {
                    pagination: false,
                    type: "fade",
                    autoplay: true,
                    interval: 7000,
                    speed: 500
                },
                sliderEvents: {
                    "splide:move": (splide, newIndex) => {
                        this.active = newIndex;
                    }
                },
                active: 0,
            };
        },
        methods: {
            goToSlide(i) {
                this.active = i;
                this.$refs.slider.goto(+i);
            }
        }
    };
</script>

<template>
    <div class="row @flex @flex-wrap imageWithSliderOnRight">
        <div class="@w-full tablet:@w-[50%] tablet:@flex-[0_0_auto] leftImage">
            <div class="imgPlaceholder"/>
            <div class="imgBox" :style="{backgroundImage: $cld.bgUrl(data.left_image, imageFormat)}">
                <div v-if="data.video_link" v-fancybox-directive="'video1'" :data-src="data.video_link" class="videoLink">
                    <img :src="playButton" alt="play button">
                </div>
            </div>
        </div>
        <div class="@w-full tablet:@w-[50%] tablet:@flex-[0_0_auto] rightContent">
            <div class="rightContentShadow"/>
            <div class="contentBox" :class="{withoutNum}">
                <div class="tablet-lg:@flex @text-center @justify-center">
                    <div class="sliderContainer @flex @flex-col">
                        <div class="l5 @pb-8">
                            {{data.right_title}}
                        </div>
                        <div class="navigations @mt-2 @mb-8">
                            <div class="ul splide-dots">
                                <span v-for="(slide, i) in data.slider" :key="i" :class="{'splide-active': i == active}">
                                    <button :aria-label="`go to slide ${+i + 1}`" @click.prevent="goToSlide(i)">{{+i + 1}}</button>
                                </span>
                            </div>
                        </div>
                        <Slider ref="slider" class="!@mb-0" :arrows="false" :options="sliderOptions" :events="sliderEvents">
                            <SplideSlide v-for="(slide, i) in data.slider" :key="i" class="p2" v-html="slide.content"/>
                        </Slider>
                        <a
                            v-if="data.video_link && withoutNum"
                            v-fancybox-directive="'tutorial'"
                            class="l5 @text-sfc-cherry @mt-8 @block @mb-10"
                            :data-src="data.video_link"
                        >
                            <u>watch the video</u>
                        </a>
                    </div>
                </div>
            </div>
            <a
                v-if="data.video_link && !withoutNum"
                v-fancybox-directive="'tutorial'"
                class="l5 @text-sfc-cherry redLink"
                :data-src="data.video_link"
            ><u>watch the video</u></a>
        </div>
    </div>
</template>

<style scoped>
    @import "@songfinch/customer/stylesheets/includes/mixins/index.pcss";

    .imageWithSliderOnRight {
        font-variant-numeric: normal;

        > div {
            position: relative;

            .imgPlaceholder {
                padding-bottom: 100%;
                @screen desktop-xl {
                    padding-bottom: 736px;
                }
            }

            .imgBox, .rightContentShadow {
                position: absolute;
                width: 100vw;
                right: 50%;
                top: 0;
                transform: translateX(50%);
                height: 100%;
                background-color: var(--sfc-black);
                @screen tablet {
                    right: 0;
                    width: 50vw;
                    transform: none;
                }

                &.rightContentShadow {
                    right: auto;
                    left: 50%;
                    transform: translateX(-50%);
                    @screen tablet {
                        left: 0;
                        transform: none;
                    }
                }

                &.imgBox {
                    background-position: center;
                    background-size: cover;
                }
            }

            &.rightContent {
                padding: 80px 15px;
                display: flex;
                justify-content: flex-end;

                .redLink {
                    position: absolute;
                    left: 50%;
                    bottom: 48px;
                    transform: translateX(-50%);
                    @screen desktop {
                        bottom: 64px;
                    }
                }

                @screen tablet-lg {
                    padding: 200px 15px;
                }

                .contentBox {
                    position: relative;
                    z-index: 2;
                    color: var(--sfc-white);
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .sliderContainer {
                        max-width: 400px;
                        width: calc(100vw - 40px);

                        @screen tablet {
                            width: 300px;
                        }
                        @screen desktop {
                            width: 400px
                        }

                        p {
                            @include font(National, 20px, 26px, 300);
                        }

                        h5 {
                            position: relative;
                            padding-bottom: 20px;
                            margin-bottom: 30px;
                            @screen tablet {
                                margin-bottom: 20px;
                            }

                            &:after {
                                content: "";
                                position: absolute;
                                width: 100px;
                                left: 0;
                                bottom: 0;
                                height: 3px;
                                background-color: var(--sfc-white);
                            }
                        }

                        .splide-dots {
                            display: none;
                        }
                    }


                    .navigations {
                        counter-reset: section;
                        padding-left: 0;

                        .splide-dots {
                            display: flex;
                            padding: 0;
                            position: static;
                            justify-content: center;

                            span {
                                @include font(National, 38px, 40px, 700);
                                @screen desktop {
                                    @include font(National, 48px, 50px, 700);
                                }
                                width: 68px;
                                height: 68px;
                                border: 2px solid var(--sfc-white);
                                opacity: 1;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin-bottom: 0;
                                cursor: pointer;
                                margin-right: 42px;
                                position: relative;
                                border-radius: 50%;

                                button {
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    left: 0;
                                    top: 0;
                                    font-feature-settings: "lnum" on;
                                }

                                &:after {
                                    content: "";
                                    width: 22px;
                                    background-color: var(--sfc-white);
                                    height: 1px;
                                    display: inline-block;
                                    position: absolute;
                                    left: calc(100% + 15px);
                                }

                                &:last-child {
                                    margin-right: 0;

                                    &:after {
                                        display: none;
                                    }
                                }

                                &.splide-active {
                                    background-color: transparent;
                                    border-color: var(--cherry);
                                    color: var(--cherry);
                                }
                            }
                        }
                    }

                    &.withoutNum {
                        position: static;

                        .sliderContainer {
                            max-width: 505px;
                            @screen desktop {
                                width: 100%;
                            }

                            .navigations {
                                position: absolute;
                                bottom: 16px;
                                left: 50%;
                                transform: translateX(-50%);

                                .splide-dots {
                                    span {
                                        width: 10px;
                                        height: 10px;
                                        border: none;
                                        margin: 0 5px;
                                        background-color: var(--sfc-medium-grey);

                                        &:before, &:after {
                                            display: none;
                                        }

                                        &.splide-active {
                                            background-color: var(--sfc-white);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        @screen tablet {
            &:deep(.sliderLeft) {
                .leftImage {
                    order: 2;
                }

                .imgBox {
                    right: auto !important;
                    left: 0 !important;
                }

                .rightContentShadow {
                    right: 0 !important;
                    left: auto !important;
                }
            }
        }

        &:deep(#newHowItWorks) {
            .sliderContainer {
                margin: auto;
                max-width: calc(100% - 30px);
                width: 350px;
                @screen tablet {
                    width: 100%;
                    max-width: 350px;
                }
                @screen tablet-lg {
                    width: 100%;
                    max-width: 400px;
                }
            }

            .navigations {
                .splide-dots span {
                    @include font(National, 30px, 32px, 700);
                    @screen desktop {
                        @include font(National, 38px, 40px, 700);
                    }

                    width: 48px;
                    height: 48px;
                    margin-right: 20px;

                    &:after {
                        width: 10px;
                        left: calc(100% + 7px);
                    }

                    &:last-child {
                        margin-right: 0;
                    }

                    @screen tablet {
                        width: 54px;
                        height: 54px;
                    }

                    @screen tablet-lg {
                        width: 56px;
                        height: 56px;
                        margin-right: 28px;

                        &:after {
                            width: 14px;
                            left: calc(100% + 9px);
                        }
                    }
                }
            }
        }
    }
</style>
